/* ChewNectar bundle cards: Buy once or Subscribe to this bundle, with delivery interval. */
(() => {
  const fmt = (c) => {
    const whole = Math.round(c) % 100 === 0;
    return '\u20B9' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  };
  const planFor = (it, d) => {
    const re = new RegExp('(^|\\D)' + d + '\\s*days?', 'i');
    const f = (it.plans || []).find((p) => /bundle/i.test(p.name) && re.test(p.name));
    return f ? f.id : null;
  };
  const start = () => document.querySelectorAll('[data-rt]').forEach((card) => {
    if (card.dataset.rtReady) return;
    card.dataset.rtReady = '1';
    let items = [];
    try { items = JSON.parse(card.dataset.items || '[]'); } catch (e) { items = []; }
    const once = Number(card.dataset.once);
    const subp = Number(card.dataset.sub);
    const subOpt = card.querySelector('[data-opt="sub"]');
    const onceOpt = card.querySelector('[data-opt="once"]');
    const fq = card.querySelector('.rt__fq');
    const btn = card.querySelector('[data-rt-btn]');
    const sum = card.querySelector('[data-rt-sum]');
    const soon = card.querySelector('[data-soon]');
    const dayBtns = [...card.querySelectorAll('[data-day]')];
    const avail = dayBtns.filter((b) => items.length && items.every((it) => planFor(it, b.dataset.day)));
    dayBtns.forEach((b) => { if (!avail.includes(b)) b.hidden = true; });
    let mode = 'once';
    let day = avail.length ? avail[0].dataset.day : null;
    if (!avail.length) {
      subOpt.classList.add('is-off');
      subOpt.querySelector('input').disabled = true;
    } else if (soon) soon.hidden = true;
    const update = () => {
      onceOpt.classList.toggle('is-on', mode === 'once');
      subOpt.classList.toggle('is-on', mode === 'sub');
      if (fq) fq.hidden = mode !== 'sub';
      dayBtns.forEach((b) => b.setAttribute('aria-pressed', String(mode === 'sub' && b.dataset.day === day)));
      if (mode === 'once') {
        btn.textContent = btn.dataset.labelOnce + ' \u00B7 ' + fmt(once);
        sum.hidden = true;
      } else {
        btn.textContent = 'Subscribe to bundle \u00B7 ' + fmt(subp);
        sum.hidden = false;
        sum.textContent = fmt(subp) + ' charged every ' + day + ' days until cancelled. Shipping calculated at checkout.';
      }
    };
    card.querySelectorAll('input[type=radio]').forEach((r) => r.addEventListener('change', () => { mode = r.value; update(); }));
    dayBtns.forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      day = b.dataset.day;
      mode = 'sub';
      subOpt.querySelector('input').checked = true;
      update();
    }));
    btn.addEventListener('click', async () => {
      const list = items.map((it) => {
        const row = { id: it.id, quantity: 1 };
        if (mode === 'sub') row.selling_plan = planFor(it, day);
        return row;
      });
      btn.setAttribute('aria-busy', 'true');
      try {
        if (window.cnAddToCart) await window.cnAddToCart(list);
        else { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) }); window.location.href = '/cart'; }
      } finally { btn.removeAttribute('aria-busy'); }
    });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();